import { Draft } from '@reduxjs/toolkit';

import { IUserData } from '../../index';

function changePasswordFailure(draft: Draft<IUserData>) {
  draft.changePassword.config.isLoading = false;
}

export default changePasswordFailure;
